const f7VueRequire = require.context(
  'framework7-vue/components',
  false,
  /(app|views?|page|block[-\w]*|icon|button|segmented|checkbox|accordion[-\w]*|list[-\w]*|fab|fab-buttons?|toolbar|navbar|popup|statusbar|nav[-\w]*|link|searchbar|tabs|tab|swiper|swiper-slide|row|col|label|input|subnavbar|panel|popup|popover|preloader|actions[-\w]*)\.js/
)

export default f7VueRequire.keys().map((f) => f7VueRequire(f).default)
